import React, { useMemo, useState } from 'react';
import * as R from 'ramda';
import { Button, FormGroup } from 'react-bootstrap';
import useFetchUserList from '../hooks/useFetchUserList';
import { useFormikContext } from 'formik';
import { isEmpty } from 'lodash';
import SelectField from 'Shared/form/SelectField';
import { assignTasks } from 'App/services/AssignmentManagerService';
import { queryClient } from 'Shared/queryClient';
import { updateWorkQueueFilters } from 'App/features/WorkQueue/workQueue.utils';
import { useUserContext } from 'App/contexts/UserContext';

export const AssignmentUserSelect = () => {
    const { data, isLoading } = useFetchUserList();
    const { values } = useFormikContext();
    const user = useUserContext();
    const { selectedRows, assignUser, filterParams } = values;
    const isSubmitEnabled = assignUser?.id && !isEmpty(selectedRows);
    const [isFormSubmitting, setIsFormSubmitting] = useState(false);

    const sortedUsers = useMemo(() => {
        if (!data) return [];
        return R.sortBy(R.compose(R.toLower, R.propOr('', 'firstName')), data);
    }, [data]);

    const assignTasksHandler = () => {
        const activityIds = [];
        for (const activityId of Object.keys(selectedRows)) {
            if (selectedRows[activityId]) {
                activityIds.push(activityId);
            }
        }
        if (activityIds.length === 0) {
            return null;
        }
        setIsFormSubmitting(true);
        const branches = assignUser && assignUser.branches ? assignUser.branches : filterParams.branches;
        const filters = updateWorkQueueFilters(filterParams);
        const assignableFilters = R.omit(['search'], filters);
        const params = {
            ...assignableFilters,
            assignee: assignUser?.id,
            onlyPcc: assignUser?.pccOnly,
            branches,
            tasks: activityIds,
        };

        return assignTasks(params)
            .then((res) => {
                queryClient.invalidateQueries(['work_queue', JSON.stringify(filters)]);
                queryClient.invalidateQueries([
                    'company',
                    user.active_company.ID,
                    'branch',
                    user.active_branch.ID,
                    'workQueue',
                    'mobileAnswersComplete',
                ]);
                return res;
            })
            .finally(() => {
                setIsFormSubmitting(false);
            });
    };

    return (
        <div className="assignment-manager-form">
            <FormGroup>
                <SelectField
                    isLoading={isLoading}
                    options={sortedUsers}
                    isClearable
                    label="Select a user to assign activities to"
                    fieldName="assignUser"
                    getOptionValue={R.prop('id')}
                    getOptionLabel={(o) => `${o.firstName} ${o.lastName} (${o.roles.join(', ')})`}
                />
            </FormGroup>
            <Button
                variant="primary"
                className="assign-tasks-btn"
                disabled={!isSubmitEnabled || isLoading || isFormSubmitting}
                onClick={assignTasksHandler}
            >
                Assign Tasks
            </Button>
        </div>
    );
};
